module.exports = __webpack_public_path__ + "static/media/activated.9712d0c7.svg";